




























































































import {Component} from 'vue-property-decorator';
import {mixins} from 'vue-class-component';
import LoaderMixin from '@/mixins/LoaderMixin';
import SnackbarMixin from '@/mixins/SnackbarMixin';
import PasswordMixin from '@/mixins/PasswordMixin';

@Component
export default class ChangePassword extends mixins(
  LoaderMixin,
  SnackbarMixin,
  PasswordMixin,
) {
  alert_show = false;
  revealCurrentPassword = false;
  revealNewPassword = false;
  revealConfirmPassword = false;
  alert_color = '';
  alert_text = '';
  currentPassword = '';
  newPassword = '';
  confirmPassword = '';

  get rules() {
    return {
      password: 'required',
      new_password: 'required|min:8|format_password',
      confirm_password: 'required|confirmed:confirmation',
    };
  }

  mounted() {
    this.$alert.hide();
    this.passwordMessage();
  }

  async onSubmit() {
    this.alert_show = false;
    const res = await this.$store.dispatch('auth/changePassword', {
      old_password: this.currentPassword,
      password: this.newPassword,
      new_password: this.confirmPassword,
    });
    if (res.status === 200) {
      this.$alert.success(res.data.message);
      this.logout();
    } else {
      this.setAlert(true, 'error', res.errors[0].message || res.message);
    }
  }

  async logout() {
    await this.$store.dispatch('auth/logout');
    this.$router.push({
      name: 'login',
      query: {
        logged_out: '1',
      },
    });
  }

  passwordMessage() {
    if (this.differentDatePassword > 76 && this.differentDatePassword < 90) {
      this.setAlert(
        true,
        'error',
        'Your password is expiring. Please update your password!',
      );
    } else if (this.differentDatePassword >= 90) {
      this.setAlert(
        true,
        'error',
        'Your password has expired. Please update your password!',
      );
    }
  }

  setAlert(show: boolean, color: string, text: string) {
    this.alert_show = show;
    this.alert_color = color;
    this.alert_text = text;
  }
}
